export default __webpack_public_path__ + "static/media/loginform.b386ba5e.png";